var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreSymbol = function SvgMoreSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    fill: "#666"
  })));
};
export default SvgMoreSymbol;